import React from 'react'
import Image from 'next/image'
import Link from 'next/link'

export interface EvirmaLogoProps {
  withoutIcon?: boolean

  signStyle?: 'default' | 'blue'
  path?: string
  width?: number
  height?: number
  alt?: string
  className?: string
}

const EvirmaLogo: React.FC<EvirmaLogoProps> = ({
                                                 withoutIcon,
                                                 path = '/',
                                                 signStyle = 'default',
                                                 width = 40,
                                                 height = 25,
                                                 alt = 'EVIRMA',
                                                 className = '',
                                               }) => {
  const signStyleClass =
    signStyle === 'blue'
      ? 'text-blue-500 hover:text-blue-600'
      : 'text-slate-900'

  return (
    <Link
      href={path}
      className={`z-10 flex items-center font-bold uppercase tracking-widest no-underline ${className}`}
    >
      {!withoutIcon && (
        <span className="mr-2 flex items-center">
          <Image
            src="/front/images/logo/evirma-logo-sign.svg"
            width={width}
            height={height}
            alt={alt}
            style={{ width: width + 'px', height: height + 'px', maxWidth: 'unset' }}
          />
        </span>
      )}

      <span className={`text-xl ${signStyleClass}`}>
        EVIRMA
      </span>
    </Link>
  )
}

export default EvirmaLogo
